import React, { useEffect, useState } from 'react';
import { Button, Drawer, Modal } from '@tencent/tea-component';
import { defaultTemplateData, templateModuleMap, useTemplateHooks } from './useTemplateHooks';
import CosImage from '@component/CosImage';
import './index.scss';
/** 创建活动模版选择弹框 */
interface ActivityTemplateModalParams {
  visible?: boolean;
  closeDrawer?: Function;
  chooseTemplate?: Function;
}
const ActivityTemplateModal = ({
  visible = true,
  closeDrawer,
  chooseTemplate,
}: ActivityTemplateModalParams) => {
  const [container, setCountainer] = useState<Element>();
  const imgPre = process.env.COS_IMAGE_DOMAIN || '';
  const { dataKeyList, chooseType, modalVisible, modalData, preview, closeModal, choose } =
    useTemplateHooks(chooseTemplate);

  useEffect(() => {
    setCountainer(document?.getElementsByClassName('ma-layout__body')?.[0]);
  }, []);

  return (
    <Drawer
      visible={visible}
      disableCloseIcon={true}
      destroyOnClose={false}
      style={{ width: '100%' }}
      onClose={() => {}}
      className="activity-template-modal"
      popupContainer={container}
    >
      <div className="activity-template-modal-header">
        <h1 className="activity-template-modal-title flex-middle">
          <i className="iconfont icon-arrow-left" onClick={() => closeDrawer?.()}></i>
          <span>开始创建您的活动</span>
        </h1>
        <p className="activity-template-modal-header_subtitle">您可以使用以下模版创建活动</p>
      </div>
      <div className="activity-template-modal_content">
        <div className="activity-template-modal_list">
          {dataKeyList.map((item) => {
            const itemData = defaultTemplateData.get(item);
            return (
              <div
                className="activity-template_list-item"
                onClick={() => item === 'custom' && choose(item)}
              >
                <div className="activity-template_list-item-content flex-middle" key={item}>
                  <div className="activity-template_list-item-left">
                    {itemData?.img ? (
                      <CosImage href={`${imgPre}${itemData?.img}`} disabledCosId width={400} />
                    ) : (
                      <div className="activity-template_list-item-left-img-default">
                        <i className="iconfont icon-add"></i>
                      </div>
                    )}
                  </div>
                  <div className="activity-template_list-item-right">
                    <h3 className="activity-template_list-item-title">{itemData?.title}</h3>
                    <p className="activity-template_list-item-desc">{itemData?.desc || ''}</p>
                  </div>
                </div>
                {item !== 'custom' && (
                  <div className="activity-template_list-item-hover">
                    <Button type="weak" onClick={() => preview(item)}>
                      预览模版
                    </Button>
                    <Button type="primary" onClick={() => choose(item)}>
                      开始创建
                    </Button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <Modal
        visible={modalVisible}
        className="create-template-preview-modal"
        onClose={closeModal}
        destroyOnClose={false}
      >
        <Modal.Body>
          <div className="create-template-preview-content">
            <div className="create-template-preview-content-left">
              <h3 className="create-template-preview-title">{modalData?.title || ''}</h3>
              <div className="create-template-preview-desc">{modalData?.desc || ''}</div>
              <div className="create-template-preview-module-box">
                <div className="create-template-preview-module-box-title">
                  {modalData?.title || ''}模版推荐您使用：
                </div>
                <div className="create-template-preview-module-box-content">
                  {modalData?.recommendList?.map((item) => {
                    const data = templateModuleMap?.get(item);
                    return (
                      <div className="create-template-preview-module-box-item">
                        <div className="create-template-preview-module-box-item-left">
                          <i
                            className={`iconfont  ${data?.icon}`}
                            style={{
                              color: data?.iconColor,
                            }}
                          ></i>
                        </div>
                        <div className="create-template-preview-module-box-item-right">
                          <p className="create-template-preview-module-box-item-title">
                            {data?.title}
                          </p>
                          <p className="create-template-preview-module-box-item-desc">
                            {data?.desc}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="create-template-preview-content-right">
              <CosImage href={`${imgPre}${modalData?.image}`} disabledCosId width={1400} />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="weak" onClick={closeModal}>
            取消
          </Button>
          <Button type="primary" onClick={() => choose(chooseType)}>
            使用该模版创建
          </Button>
        </Modal.Footer>
      </Modal>
    </Drawer>
  );
};
export default ActivityTemplateModal;
